import React, { createContext, useContext, useRef, useState } from "react";
import { useOutsideEvent, useFullScreen } from "@cadenza/ui-hooks";
import { useRADSync } from "./hooks";

import RADManagerUI from "./RADManagerUI.jsx";
import "../styles/RAD.base.css";
import "../styles/RAD.layout.css";
import "../styles/RAD.palette.css";
import "../styles/RAD.svg.css";
import "../styles/RAD.dragdrop.css";
import "../styles/RAD.scrollbars.css";
import "../styles/RAD.shapes.css";

const RADManagerContext = createContext();

export const useRADManager = () => {
  const context = useContext(RADManagerContext);
  if (!context) {
    throw new Error("useRADManager must be used within a RAD Provider");
  }
  return context;
};

const RADManager = () => {
  const {
    setCurrentRAD,
    currentRAD,
    handleNewRAD,
    handleDeleteRAD,
    handleDeleteAllRADs,
  } = useRADSync();
  // UI state
  const dropdownref = useRef(null);
  const [dropdown, setDropdown] = useState(false);
  const toggleDropdown = () => setDropdown(!dropdown);
  useOutsideEvent(dropdownref, dropdown, () => setDropdown(false));
  const { fullScreen, toggleScreenMode } = useFullScreen();

  return (
    <RADManagerContext.Provider
      value={{
        // UI state
        dropdownref,
        dropdown,
        setDropdown,
        toggleDropdown,
        fullScreen,
        toggleScreenMode,

        // RAD logic
        setCurrentRAD,
        currentRAD,
        handleNewRAD,
        handleDeleteRAD,
        handleDeleteAllRADs,
      }}
    >
      <RADManagerUI />
    </RADManagerContext.Provider>
  );
};

export default RADManager;
